/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RequiresImages/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function RequiresImages({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Procedures/Content/Content/Procedure/RequiresImages"
  
}) {
let procedureRequiresImagesValueData = fromData.useDataFormat({ viewPath,
context: 'procedure',
path: 'requires_images',
format: fromFormat.booleanToYesNo,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="procedure.requires_images"
 format="/Data/format.js booleanToYesNo"
 text={procedureRequiresImagesValueData}
 size="small"
/>
{children}
</React.Fragment>)
}